import { render, staticRenderFns } from "./iButton.vue?vue&type=template&id=f9581728&scoped=true&"
import script from "./iButton.vue?vue&type=script&lang=js&"
export * from "./iButton.vue?vue&type=script&lang=js&"
import style0 from "./iButton.vue?vue&type=style&index=0&id=f9581728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9581728",
  null
  
)

export default component.exports